/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Sendnewsletterenabled2Inputs */

const en__field_sendnewsletterenabled2 = /** @type {(inputs: _Field_Sendnewsletterenabled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`send "Further Workshops" newsletter`)
};

const de__field_sendnewsletterenabled2 = /** @type {(inputs: _Field_Sendnewsletterenabled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Newsletter "Weitere Workshops" versenden`)
};

/**
* | output |
* | --- |
* | "send \"Further Workshops\" newsletter" |
*
* @param {_Field_Sendnewsletterenabled2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_sendnewsletterenabled2 = /** @type {((inputs?: _Field_Sendnewsletterenabled2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Sendnewsletterenabled2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_sendnewsletterenabled2(inputs)
	return de__field_sendnewsletterenabled2(inputs)
});
export { _field_sendnewsletterenabled2 as "_field_sendNewsletterEnabled" }